import { SPORTS }
    from "../data/courts";

/* ---------------------------------- */
/* SPORT CONFIG */
/* ---------------------------------- */

export const SPORT_CONFIG =

    SPORTS.reduce(

        (acc, sport) => {

            acc[sport.key] = {

                label:
                    sport.label,

                color:
                    sport.color,

                emoji:
                    sport.emoji || "🏸",
            };

            return acc;

        },

        {}
    );

/* ---------------------------------- */
/* STATUS COLORS */
/* ---------------------------------- */

export function getStatusColor(
    status
) {

    switch (status) {

        case "confirmed":

            return {

                bg:
                    "rgba(0,255,136,0.12)",

                border:
                    "rgba(0,255,136,0.25)",

                text:
                    "#00ff88",
            };

        case "cancelled":

            return {

                bg:
                    "rgba(255,107,107,0.12)",

                border:
                    "rgba(255,107,107,0.25)",

                text:
                    "#ff6b6b",
            };

        default:

            return {

                bg:
                    "rgba(255,255,255,0.08)",

                border:
                    "rgba(255,255,255,0.15)",

                text:
                    "#ffffff",
            };
    }
}

/* ---------------------------------- */
/* FILTER ORDERS */
/* ---------------------------------- */

export function filterOrdersByStatus({

    orders = [],

    status,
}) {

    if (
        status === "all"
    ) {

        return orders;
    }

    return orders.filter(

        (order) =>

            order.bookingStatus ===
            status
    );
}

/* ---------------------------------- */
/* TOTAL HOURS */
/* ---------------------------------- */

export function calculateTotalHours(
    orders = []
) {

    return orders.reduce(

        (
            total,
            order
        ) => {

            const slotHours =

                (order.slots || [])

                    .reduce(

                        (
                            sum,
                            slot
                        ) =>

                            sum +
                            (
                                slot.duration || 0
                            ),

                        0
                    );

            return (
                total +
                slotHours
            );

        },

        0
    );
}